




































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import _ from "lodash";
@Component
export default class ViewPickListSerial extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: 0 }) id: number;
  @Prop({ type: String, default: "" }) code: string;
  @Prop({ type: String, default: "" }) pickedByName: string;

  title: string = Util.L("Thông tin Phiếu đặt và YCXK");
  items = [];
  loading = false;
  cancel() {
    this.$emit("input", false);
  }
  get list() {
    var index = 1;
    this.items.forEach(function(item) {
      item.orderNo = index;
      index++;
    });
    return this.items;
  }
  getSoRequests() {
    this.loading = true;
    this.$store
      .dispatch({
        type: "picklist/getSoRequests",
        data: {
          id: this.id,
        },
      })
      .then((result) => {
        this.items = result;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  created() {}
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      if (this.id > 0) this.getSoRequests();
    }
  }
  columns = [
    {
      title: this.L("Order"),
      width: 60,
      fixed: "left",
      key: "orderNo",
    },
    {
      title: this.L("SoRequestCode"),
      width: 200,
      align: "center",
      slot: "soRequest",
    },
    {
      title: this.L("SoCode"),
      width: 200,
      align: "center",
      slot: "so",
    },
    {
      title: this.L("Customer"),
      align: "center",
      slot: "customer",
    },
  ];
}
